import { SPRITE_VERSION } from '@modules/common/icons/generated/sprite-version';

/**
 * Icon sprite delivery — shared constants.
 *
 * The full SVG sprite is served once from the {@link ICON_SPRITE_URL} route (a
 * cacheable, same-origin file). The design system's `<Icon>` is pointed at it
 * via `setIconSpriteHref` (see `src/app/layout.tsx` and
 * `<IconSpriteLoader>`), so it renders a native `<use href="/icons/sprite.svg#name">`
 * instead of relying on the sprite being present in the current document. This
 * keeps the ~355KB sprite (and its RSC-payload duplicate) out of every page's
 * HTML — a first-paint (FCP) win — and lets the browser resolve/cache it
 * without any client-side fetch+DOM-injection step.
 *
 * The `?v=` fingerprint is a content hash of the whole generated icon set
 * (`scripts/build-sprite.mjs`), not just the brand's own subset — because
 * `extractIcons` in `scripts/build-assets.mjs` only extracts the symbols this
 * build's sources actually reference. Without it, a deploy that starts
 * referencing an icon the previous build omitted would leave a returning
 * browser's long-cached `/icons/sprite.svg` response missing that symbol
 * (a blank icon) until the route's Cache-Control TTL expires.
 */

/** Same-origin route serving the full sprite (see src/app/icons/sprite.svg). */
export const ICON_SPRITE_URL = `/icons/sprite.svg?v=${SPRITE_VERSION}`;
